import React from 'react';
import Hero from './HeroSection/Hero';
import styled from 'styled-components';
import { useForm, Controller } from 'react-hook-form';
import CustomInput from './Inputs/CustomInput';
import SubmitButton from './Buttons/SubmitButton';
import useConfigs from '../hooks/useConfigs';

// ##### Estilos #####
const Container = styled.div`
  position: relative;
`;

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // background-color: #fff;
  margin-top: 4rem;
`;

const InputContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 50vw;
`;

export const PageDoctorFamedic = () => {
  window.scroll(0, 0)
  const { handleSubmit, control } = useForm({ mode: 'onBlur' });
  const { fontSizeMultiplier, theme, themeSelected } = useConfigs();
  const root = document.querySelector('#root');
  const currentColor = themeSelected == 'light' ? '#fff' : '#012b2b';
  root.setAttribute('style', `background-color: ${currentColor};`);

  const onSubmit = async (data) => {

  };

  return (
    <Container>
      <Hero
        title='Doctor Famedic'
        subtitle='AGENDAR CONSULTAR Y CANCELAR CITAS MEDICAS DESCARGAR TUS AUTORIZACIONES DESCARGAR TUS RESULTADOS ACTUALIZAR TUS DATOS DE CONTACTO'
        color={themeSelected == 'light' ? '#ffff' : '#012b2b'}
        imgSrc='img/Servicios/seccion-servicios.jpg'
      />

      <FormContainer onSubmit={handleSubmit(onSubmit)}>
        <InputContainer>
          <Controller
            name='DocNumero'
            control={control}
            rules={{ required: 'El número de documento es requerido' }}
            render={({
              field: { value, onBlur, onChange },
              fieldState: { error },
            }) => (
              <CustomInput
                value={value}
                onChange={onChange}
                onBlut={onBlur}
                label='Número de identificación *'
                width='100%'
                error={error}
                type='number'
              />
            )}
          />
        </InputContainer>

        <InputContainer>
          <Controller
            name='dateBorn'
            control={control}
            rules={{ required: 'Fecha de nacimiento requerida' }}
            render={({
              field: { value, onBlur, onChange },
              fieldState: { error },
            }) => (
              <CustomInput
                value={value}
                onChange={onChange}
                onBlut={onBlur}
                label='FECHA DE NACIMIENTO *'
                width='100%'
                error={error}
                type='date'
              />
            )}
          />
        </InputContainer>

        <SubmitButton label='Iniciar sesión' />
      </FormContainer>
    </Container>
  );
};
